import { ThunderDispatcher } from '../thunder-dispatcher.js';
export class ThunderDispatcherV3 extends ThunderDispatcher {
}
//# sourceMappingURL=types.js.map